import { useFormContext } from "react-hook-form";

import SelectedCheckbox from "@/assets/ux/SelectedCheckbox.svg?react";
import UnselectedCheckbox from "@/assets/ux/UnselectedCheckbox.svg?react";
import { Checkbox } from "@/components/Interface/FormFields/Checkbox/Checkbox";

import { ItemizedBillListIdForm } from "./ItemizedBillOverview";

type ItemizedBillCheckboxProps = {
  serviceId: number;
  period: string;
};

export const ItemizedBillCheckbox = ({
  serviceId,
  period,
}: ItemizedBillCheckboxProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext<ItemizedBillListIdForm>();

  return (
    <Checkbox<ItemizedBillListIdForm>
      id={`itemized-bill-checkbox-${serviceId}-${period}`}
      name="selectedItems"
      value={`${serviceId}|${period}`}
      errors={errors}
      register={register}
      selectedIcon={<SelectedCheckbox />}
      unselectedIcon={<UnselectedCheckbox />}
    />
  );
};
